import { EVENT } from "../config";
import { Countdown } from "./Countdown";

export const Hero = () => {
  const scrollToWelcome = () => {
    document.getElementById("welcome")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="w-full bg-[#F2EDE3]" data-testid="hero-section">
      <div className="flex flex-col items-center px-6 pb-16 pt-20 text-center md:pb-20 md:pt-28">
        <h1 data-testid="hero-logo">
          <img
            src={EVENT.logo}
            alt={`${EVENT.name} ${EVENT.age}`}
            className="animate-logo-reveal mx-auto w-[11.5rem] max-w-[65vw] sm:w-[14.5rem] md:w-[17rem] lg:w-[19rem]"
          />
        </h1>
      </div>

      <div className="animate-fade-up-slow px-6 md:px-16" style={{ animationDelay: "0.3s" }}>
        <img
          src={EVENT.heroImage}
          alt="Sandhamn"
          className="mx-auto w-full max-w-6xl"
        />
      </div>

      <div className="flex flex-col items-center px-6 pb-10 pt-16 text-center md:pb-14 md:pt-20">
        <Countdown />
        <button
          onClick={scrollToWelcome}
          data-testid="hero-explore-button"
          className="group mt-14 inline-flex items-center gap-3 text-sm font-light uppercase tracking-[0.25em] text-[#7A6A5E] transition-colors hover:text-[#3F3A32]"
        >
          Explore the Weekend
          <span className="inline-block transition-transform duration-300 group-hover:translate-y-0.5">↓</span>
        </button>
      </div>
    </section>
  );
};
